/* eslint-disable @typescript-eslint/camelcase */
import { BcsFlag } from "../unleash";

const BcsPermissionBulkPrint = {
  config_max_stt_input_bulk_print: new BcsFlag.NumberFlag(500)
}

export const FlagsPermissionBulkPrint = {
  ...BcsPermissionBulkPrint
};

export function initFlagsPermissionBulkPrint() {
  // register flags with namespaces for better grouping
  BcsFlag.register("medusa", FlagsPermissionBulkPrint);
}
